export default {
  logoDescription: 'Select a file (.JPG o .GIF) with logo of your company to add it to the PDF. The image cant exceed 200 pixels high and 200 pixels wide',
  ownerDescription: 'You can select the XSLT to transfrom from proprietary format to UBL 1.0.',
  ownerFile: 'XSLT file',
  inputDescription: 'File name',
  logoLabel: 'Logo',
  pdfConfg: 'Select the PDF template to display the invioces, once changed, the invoices will be associated with the new template.',
  template: 'Template',
  seeExample: 'Invoice example',
  formatDescription: 'Select one of the following formats for the receipt of signed invoices. If you select the value "Formato entrante" (Incoming format), you will receive signed invoices in the format used by the invoice issuer',
  format: 'Format',
  logoFormats: '{0}: JPG, GIF',
  titles: {
    first: 'Select the format in which you want to receive the invoices.',
    second: 'Setting up the PDF template for invoice viewing',
    third: 'Logo configuration in the invoice display',
    fourth: 'Configuration of proprietary format to be able to import invoices into the platform'
  },
  billFormat: {
    text: '{0}: 200 pixels high and 200 pixels wide',
    label: 'Dimensions',
    file: '{0}: XSLT'
  }
}
